import { Component, OnInit, inject } from "@angular/core";
import { IInfoCardData, ISearchCriteria } from "@tylertech/tyler-api-types";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DataSearchService } from "@tylertech/data-load-module";

enum SearchProvidersWithCustomDetails
{
    ProjectAccounts = "PAAccount.InfoCardProvider",
    ProjectAccounting = "PAAccounting.InfoCardProvider",
    EmployeeDeductions = "EmployeeDeductionsInfoCardProvider",
}

export interface InfoCardSearchDialogData
{
    readonly criteria: ISearchCriteria<IInfoCardData>;
}

@Component({
    selector: "info-card-search-dialog-component",
    templateUrl: "./infoCardSearchDialog.tmpl.html",
    standalone: false
})
export class InfoCardSearchDialogComponent implements OnInit
{
    private readonly $dataSearchService = inject<DataSearchService<IInfoCardData>>(DataSearchService);

    isLoaded: boolean;
    criteria: ISearchCriteria<IInfoCardData>;

    constructor()
    {
        const data = inject<InfoCardSearchDialogData>(MAT_DIALOG_DATA);

        this.criteria = data.criteria;
    }

    get HasResults(): boolean { return this.criteria.SearchResult?.length > 0; }
    get cardProviderId(): string { return this.criteria.SearchProviderId; }

    get detailComponent(): string
    {
        switch (this.criteria.SearchProviderId)
        {
            case SearchProvidersWithCustomDetails.ProjectAccounts:
                return "ProjectAccountDetailCard";
            case SearchProvidersWithCustomDetails.ProjectAccounting:
                return "projectAccountSearchDetailCard";
            case SearchProvidersWithCustomDetails.EmployeeDeductions:
                return "VarianceDetailCard";
            default:
                return undefined;
        }
    }

    get headerComponent(): string
    {
        switch (this.criteria.SearchProviderId)
        {
            case SearchProvidersWithCustomDetails.ProjectAccounts:
                return "ProjectAccountHeaderCard";
            default:
                return undefined;
        }
    }

    ngOnInit(): void
    {
        if (this.criteria.Settings)
        {
            this.criteria.Settings = {};
        }
        this.criteria.Settings.Add = this.criteria.Settings.Add || false;
        this.criteria.Settings.NotForSearchView = this.criteria.Settings.NotForSearchView || true;
        this.criteria.Settings.IgnoreAdditionalInfo = this.criteria.Settings.IgnoreAdditionalInfo || true;

        this.$dataSearchService.Search(this.criteria)
            .then((result: ISearchCriteria<IInfoCardData>): void =>
            {
                result.SearchResult.forEach(infocard =>
                {
                    infocard.Metadata = result.Metadata;
                });
                this.criteria = result;
            })
            .finally(() =>
            {
                this.isLoaded = true;
            });
    }
}
